import React, { useEffect, useState } from "react";
import "./ChatBot_Dashboard.css";
import { GetTotalGeneratedQA } from "../../Api_Qdrant/Flask_Apis";
import { GetDashboardCountSql, GetRecentConnection } from "../../Apis_chatbot/apis";
import { FileText, HelpCircle, MessageSquareText, Users, UserCheck } from "lucide-react";
import totalAnsweredSvg from "../../assets/icons/total-unanswerd.svg";
import conversationTodaySvg from "../../assets/icons/conversation-today.svg"
import totalGuestUserSvg from "../../assets/icons/total-guest-users.svg"
import totalLoggedUser from "../../assets/icons/active-users.svg"
import totalSubscribersSvg from "../../assets/icons/total-subscribers.svg"
import addNewUserSvg from "../../assets/icons/new-user-add.svg"
import newArticlePublishSvg from "../../assets/icons/new-article-published.svg"
import activeNewsletterSvg from "../../assets/icons/active-newsLetter.svg"
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import LoadingSpinner from "../../app/components/Loader/LoadingSpinner";

const data = [
  { month: "Jan", users: 4500, articles: 2200 },
  { month: "Feb", users: 4800, articles: 2400 },
  { month: "Mar", users: 5600, articles: 3100 },
  { month: "Apr", users: 6500, articles: 4200 },
  { month: "May", users: 6800, articles: 4500 },
  { month: "Jun", users: 7800, articles: 5600 },
  { month: "Jul", users: 8400, articles: 6100 },
  { month: "Aug", users: 8300, articles: 5900 },
  { month: "Sep", users: 9100, articles: 6800 },
  { month: "Oct", users: 9800, articles: 7400 },
  { month: "Nov", users: 10400, articles: 8000 },
  { month: "Dec", users: 12200, articles: 9500 },
];


function ChatbotDashboard() {
  const [showBot, setShowBot] = useState(true);
  const [showDashboard, setShowDashboard] = useState(false);
  const [recentUsers, setRecentUsers] = useState([]);
  const [dashboardData, setDashboardData] = useState({
    total_qa: 0,
  });
  const [dashboardDatasql, setDashboardDatasql] = useState({
    total_unanswered_qa: 0,
    total_conversations: 0,
    total_guest_users: 0,
    total_logged_users: 0,

  });
  const username = localStorage.getItem("username") || "Admin";
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    // Fetch dashboard data from backend
    //fetchDashboardData();
    fetchGetRecentConnection();
    fetchDashboardDataSql();
    // Bot will hide after 3 seconds
    const timer = setTimeout(() => {
      setShowBot(false);
      setTimeout(() => setShowDashboard(true), 400); // small delay for smooth animation
    }, 1000);

    return () => clearTimeout(timer);
  }, []);



  const fetchDashboardDataSql = async () => {
    try {
      const res = await GetDashboardCountSql();
      if (res) {
        const data = res.result_value
        setDashboardDatasql({
          total_unanswered_qa: data.totalUnansweredQuestions,
          total_conversations: data.totalConnectionsToday,
          total_guest_users: data.totalGuestUsers,
          total_logged_users: data.totalLoggedUsers,
        });
      }

    } catch (error) {
      console.log("get erorr");
    }
  }

  const fetchGetRecentConnection = async () => {
    try {

      const res = await GetRecentConnection();
      if (res) {
        console.log(res);
        setRecentUsers(res.result_value)
      }

    } catch (error) {
      console.log("get erorr");
    }
  }

  const fetchDashboardData = async () => {
    try {
      const response = await GetTotalGeneratedQA();
      if (response) {
        setDashboardData({
          total_qa: response.result.active_count || 0,
        });
      } else {
        console.error("Failed to fetch dashboard data");
      }
      setIsLoading(false)
    }
    catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  }
  return (
    <>
    {isLoading ? (<LoadingSpinner />) : (
    <div className="dashboard_main">
      {/* Bot Animation */}
      {/* {showBot && (
        <div className="bot_intro">
          <div className="bot_avatar">
            🤖
          </div>
          <p className="bot_text">Hello {username}, loading your dashboard...</p>
        </div>
      )} */}

      {/* Dashboard Section */}
      {showDashboard && (
        <div className="dashboard_content">
          {/* Summary Cards */}
          <div className="dashboard_details_card_wraper">
            <div className="dashboard_details_card">
              <div className="dashboard_details_card_inner_wraper">
                <div className="dashboard_details_card_img">
                  <img src={totalAnsweredSvg} alt="Images" />
                  <p>Total Unanswered QA</p>
                </div>
                <div className="dashboard_card_requested_text">
                  <span>{dashboardDatasql.total_unanswered_qa}</span>
                  <p>Uploaded</p>
                </div>
              </div>
            </div>

            <div className="dashboard_details_card">
              <div className="dashboard_details_card_inner_wraper">
                <div className="dashboard_details_card_img">
                  <img src={totalAnsweredSvg} alt="Images" />
                  <p>Q&A</p>
                </div>
                <div className="dashboard_card_requested_text">
                  <span>{dashboardData.total_qa}</span>
                  <p>Generated</p>
                </div>
              </div>
            </div>

            <div className="dashboard_details_card">
              <div className="dashboard_details_card_inner_wraper">
                <div className="dashboard_details_card_img">
                  <img src={conversationTodaySvg} alt="Images" />
                  <p>Conversations Today</p>
                </div>
                <div className="dashboard_card_requested_text">
                  <span>{dashboardDatasql.total_conversations}</span>
                  <p>with Agent</p>
                </div>
              </div>
            </div>

            <div className="dashboard_details_card">
              <div className="dashboard_details_card_inner_wraper">
                <div className="dashboard_details_card_img">
                  <img src={totalGuestUserSvg} alt="Images" />
                  <p>Total Guest Users</p>
                </div>
                <div className="dashboard_card_requested_text">
                  <span>{dashboardDatasql.total_guest_users}</span>
                </div>
              </div>
            </div>

            <div className="dashboard_details_card">
              <div className="dashboard_details_card_inner_wraper">
                <div className="dashboard_details_card_img">
                  <img src={totalLoggedUser} alt="Images" />
                  <p>Total Logged Users</p>
                </div>
                <div className="dashboard_card_requested_text">
                  <span>{dashboardDatasql.total_logged_users}</span>
                </div>
              </div>
            </div>
          </div>


          <div className="dashboard-chart-main-wraper chat-dashboard-chart-main-wraper">
            <div className="dashboard-overview">
              <div className="tile-wraper">
                <div className="title-group">
                  <h2>Content Overview</h2>
                  <p className="subtitle">Monthly user and article growth</p>
                </div>
                <div className="legend">
                  <div className="legend-item"><span className="dot purple"></span> Users</div>
                  <div className="legend-item"><span className="dot blue"></span> Articles</div>
                </div>
              </div>
              <div style={{ width: "100%", height: 380 }}>
                <ResponsiveContainer>
                  <AreaChart data={data}>

                    {/* Gradients */}
                    <defs>
                      <linearGradient id="usersGradient" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#7C3AED" stopOpacity={0.4} />
                        <stop offset="100%" stopColor="#7C3AED" stopOpacity={0.05} />
                      </linearGradient>

                      <linearGradient id="articlesGradient" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#0F172A" stopOpacity={0.4} />
                        <stop offset="100%" stopColor="#0F172A" stopOpacity={0.05} />
                      </linearGradient>
                    </defs>

                    {/* Grid */}
                    <CartesianGrid
                      strokeDasharray="4 4"
                      vertical={false}
                      stroke="#CBD5E1"
                    />

                    {/* Axes */}
                    <XAxis dataKey="month" />
                    <YAxis
                      tickFormatter={(value) => `${value / 1000}k`}
                    />

                    {/* Tooltip & Legend */}
                    <Tooltip />
                    <Legend align="right" />

                    {/* Users */}
                    <Area
                      type="monotone"
                      dataKey="users"
                      stroke="#7C3AED"
                      strokeWidth={2.5}
                      fill="url(#usersGradient)"
                      dot={false}
                    />

                    {/* Articles */}
                    <Area
                      type="monotone"
                      dataKey="articles"
                      stroke="#0F172A"
                      strokeWidth={2.5}
                      fill="url(#articlesGradient)"
                      dot={false}
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </div>
            <div className="dashboard-overview">
              <div className="tile-wraper title-wraper2">
                <div className="title-group">
                  <h2>Activity Feed</h2>
                  <p className="subtitle">Recent activities</p>
                </div>
                <div className="legend">
                  <span className="view-all">View All</span>
                </div>
              </div>
              <ul className="activity-list">
                <li className="activity-item">
                  <div className="icon-box">
                    <img
                      src={addNewUserSvg}
                      alt="Registered User"
                    />
                  </div>
                  <div className="activity-info">
                    <p>New user registered: Ajay Singh</p>
                    <span>2 min ago</span>
                  </div>
                </li>
                <li className="activity-item">
                  <div className="icon-box">
                    <img
                      src={newArticlePublishSvg}
                      alt="Registered User"
                    />
                  </div>
                  <div className="activity-info">
                    <p>New article published: Tech Trends 2024</p>
                    <span>10 min ago</span>
                  </div>
                </li>
                <li className="activity-item">
                  <div className="icon-box">
                    <img
                      src={activeNewsletterSvg}
                      alt="Registered User"
                    />
                  </div>
                  <div className="activity-info">
                    <p>Newsletter sent to 1,234 subscribers</p>
                    <span>1 hour ago</span>
                  </div>
                </li>
                <li className="activity-item">
                  <div className="icon-box">
                    <img
                      src={totalSubscribersSvg}
                      alt="Registered User"
                    />
                  </div>
                  <div className="activity-info">
                    <p>New blog post created: AI Insights</p>
                    <span>3 min ago</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>


          {/* Example Table */}
          <div className="role-box">
            <h2 className="mb-0">Recent Conversations</h2>
          </div>
          <div className="main_widget">
            <div className="main_widget_body">
              <div className="table-responsive">
                <table>
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>User's Name</th>
                      <th>Agent Name</th>
                      <th>Chat Start Time</th>
                      <th>Chat End Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recentUsers && recentUsers.length > 0 ? (
                      recentUsers.map((user, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{user.userName || "-"}</td>
                          <td>{user.agentName || "-"}</td>
                          <td>
                            {new Date(user.startedAt).toLocaleString(undefined, {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            })}
                          </td>

                          <td>
                            {user.endedAt
                              ? new Date(user.endedAt).toLocaleString(undefined, {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                              })
                              : <span style={{ color: "green", fontWeight: "bold" }}>Still Running</span>}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" style={{ textAlign: "center" }}>No users found</td>
                      </tr>
                    )}
                  </tbody>

                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
    )}
    </>
  );
}

export default ChatbotDashboard;
